import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	plansText: {
		id: 'atlassian-navigation.plans.menu.content.empty.plans-text',
		defaultMessage: 'Create up-to-date plans from multiple teams and projects.',
		description:
			'Dropdown empty view description. Will be visible when there are no recent plans in the Plans navigation dropdown',
	},
	createPlan: {
		id: 'atlassian-navigation.plans.menu.content.empty.create-plan',
		defaultMessage: 'Create plan',
		description: 'Label for the create plan button',
	},
	createDemoPlan: {
		id: 'atlassian-navigation.plans.menu.content.empty.create-demo-plan',
		defaultMessage: 'Create demo plan',
		description: 'Label for the create demo plan button',
	},
	learnMore: {
		id: 'atlassian-navigation.plans.menu.content.empty.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Dropdown empty view link. Will be visible when there are no recent plans in the Plans navigation dropdown. Navigates to Plans documentation',
	},
});
